import React from 'react';
import { componentService } from 'js/services/component.service';

export const SportsbookWidget = React.lazy(() => import(/* webpackChunkName: "sportsbook-widget" */ './SportsbookWidget'));

// <hub2-sportsbook-widget widgetname="bet-history"></hub2-sportsbook-widget>
componentService.registerWebContentComponents({ SportsbookWidget });
